import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SERVICES_ORDERS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SERVICES_ORDERS: '/services-orders/',
    NEW_SERVICES_ORDER: (id: number) => `/admin/new-orders/${id}`,
    NEW_ORDER_STATUS: '/admin/new-order-status',
    CLIENT_PAYMENT_CAPTURE: (orderID: number) =>
      `/admin/client-payment-capture/${orderID}`,
    DELIVERED_PAYMENT_TO_PROVIDER: (orderID: number) =>
      `/admin/delivered-payment-to-provider/${orderID}`,
    UPDATE_NEW_ORDER_ZAP: (id: number) => `/admin/update-new-order-zap/${id}`,
  }),
  V2: createEndpoints('v2', {
    SOPRA_SERVICES_REQUEST: '/admin/classifications/applications/',
    SOPRA_SERVICE_DETAILS: (id: number) => `/admin/classifications/applications/${id}/`,
  }),
} as const;
